"use strict";

module.exports = {
  version: '0.1.50',
  defaultApiEndpoint: 'https://testing-api.soulplatform.com/',
  defaultPhoneValidationMethod: 'email',
  defaultAlbumPrivacy: 'public',
  defaultAlbumName: 'default',
  defaultPoolInterval: 5000,
  dnsProvidersUrls: [// Google
  'https://8.8.8.8/resolve', 'https://8.8.4.4/resolve', // Cloudflare
  'https://1.1.1.1/dns-query', 'https://1.0.0.1/dns-query', // Quad9
  'https://9.9.9.9:5053/dns-query', 'https://149.112.112.112:5053/dns-query']
};